import { StaticPageLayout } from '../components/layout/StaticPageLayout'

const SUPPORT_MARKDOWN = `Need help? We're here.

The fastest way to reach us is by email. We aim to respond within 24 hours, often sooner.

**Email:** support@pantryioapp.com

---

## Frequently Asked Questions

### How do I cancel my subscription?

You can cancel anytime. Your access continues until the end of your current billing period.

**If you subscribed on iPhone or iPad:**
Open Settings on your device → tap your name at the top → Subscriptions → PantryIO → Cancel Subscription.

**If you subscribed on the web:**
Sign in at pantryioapp.com → Settings → Manage Subscription → Cancel.

### How do I get a refund?

Subscription refunds are handled differently depending on where you subscribed. See our [Refund Policy](/refund-policy) for details.

### My receipt didn't scan correctly. What can I do?

Try these in order:

1. **Lighting matters.** Take the photo somewhere bright and flat. Avoid shadows over the receipt.
2. **Hold still.** Blurry photos are the most common cause of missed items.
3. **Crop tight.** If the photo includes a lot of background, the scanner can get confused.
4. **Manually add what's missing.** Tap "+ Add Item" on the unpack screen to add anything the scanner missed.

If you're consistently having scanning issues, email us a sample receipt photo and we'll take a look.

### How do I add my partner or family to my household?

Go to **Settings → Household → Invite Member**. You'll get a link to share. Anyone who joins through that link will see the same inventory, shopping lists, and recipes.

### What happens to my data if I cancel?

Your data stays in your account. If you resubscribe later, everything is right where you left it. If you want your account fully deleted, you can do that anytime at [pantryioapp.com/delete-account](/delete-account).

### How does PantryIO work with Alexa?

Enable the "Pantry Plus" skill in the Alexa app, then sign in to your PantryIO account through the Alexa skill settings. Once linked, you can say things like "Alexa, ask Pantry Plus what's running low" or "Alexa, tell PantryIO I'm out of milk."

### I have feedback or a feature request.

We read everything. Email support@pantryioapp.com and tell us what you think.
`

export default function Support() {
  return (
    <StaticPageLayout
      documentTitle="Support — PantryIO"
      heading={<>PantryIO <em className="italic">Support</em></>}
      markdown={SUPPORT_MARKDOWN}
    />
  )
}
